import { inject, Injectable } from "@angular/core";
import { ofType } from "@ngrx/effects";
import { EffectsBase } from "clicklease-ui-elements";
import { catchError, first, map, mergeMap, of } from "rxjs";
import { updateEquipmentLocationData, updateEquipmentLocationDataError, updateEquipmentLocationDataSuccess } from "./equipment-location-form.actions";
import { PersonalInformationIdSelector } from "../personal-information/personal-information.selectors";
import { RoseService } from "../../services";

@Injectable()
export class EquipmentLocationFormEffect extends EffectsBase {
    readonly #roseId = this.store.selectSignal(PersonalInformationIdSelector);
    private readonly roseService: RoseService = inject(RoseService);

    updateBankInformationEffect = this.createEffect(() =>
        this.actions.pipe(
            ofType(updateEquipmentLocationData),
            mergeMap(({ locationData }) => {
                return this.roseService.updateEquipmentLocation(this.#roseId(), locationData).pipe(
                    map(() => updateEquipmentLocationDataSuccess()),
                    catchError((error) => of(updateEquipmentLocationDataError({ error: error.message }))),
                    first()
                )
            }))
    );
}